import React, { Component } from "react";
import { withRouter } from "../../../withRouter";
import { InputAdornment } from "@mui/material";
import { Menu } from "@mui/material";
import IconButton from "@mui/material/IconButton";
import SearchIcon from "@mui/icons-material/Search";
import TextField from "@material-ui/core/TextField";
import CloseIcon from "@material-ui/icons/Close";
import store from "../../../redux/store";
import _ from "lodash";
import Pagination from "../../givBee/pagination/Pagination";
import Utils from "../../../provider/Utils";
import AdminFetchServerData from "../../../provider/AdminFetchServerData";
import AdminMenuWithBreadScrum from "../adminMenu/AdminMenuWithBreadScrum";
import { MESSAGE_TYPES } from "../../../provider/Enums";
import { ArrowBack, ArrowForward } from "@mui/icons-material";
import { GetForTestAndSend_Url } from "../../../provider/ServiceUrl";
class AccountSendHistory extends Component {
  header = store.getState().adminHeader.adminHeader;
  title = "Usage History";
  breadCrumb = [
    { pageid: "/accountList", uiname: "Accounts List" },
    { pageid: "/viewAccount", uiname: "Account" },
    { pageid: "", uiname: "Usage History" },
  ];
  constructor(props) {
    super(props);
    let accountId = "";
    let eventId = "";
    let eventName = "";
    let businessDomain = null;
    if (props.state) {
      accountId = props.state.accountId;
      eventId = props.state.eventId;
      eventName = props.state.eventName;
      businessDomain = props.state.businessDomain;
    }
    this.state = {
      accountId: accountId,
      eventId: eventId,
      eventName: eventName,
      businessDomain: businessDomain,
      messageContent: "",
      searchText: "",
      messageId: "",
      sendMessageLog: null,
      mmsUrl: "",
      keyword: "",
      messageName: "",
      messageType: null,
      textMessage: "",
      closingTextMessage: "",
      questionItems: [],
      currentIndex: 0,
      index: 0,
      pageNo: 0,
      pageSize: 20,
      smsMessageLogList: [],
      open: false,
      getUpdatePermission: false,
      getDeletePermission: false,
      render: false,
    };
    this.getSendHistoryList(this.state.pageNo, this.state.pageSize);
    this.debouncedSearch = _.debounce(this.getSendHistoryList, 800);
  }

  onSearchChange(e) {
    this.setState({ searchText: e.target.value });
    this.debouncedSearch(0, this.state.pageSize);
  }

  getSendHistoryList(pageNo, pageSize) {
    const postObject = {
      //   header: this.header,
      header: {
        ...this.header,
        tid: this.state.accountId,
      },
      event: { id: this.state.eventId },
      page: {
        searchText: this.state.searchText,
        pageNo: pageNo,
        pageSize: pageSize,
      },
    };

    AdminFetchServerData.callPostService(
      "/messageLogReportms/getReportData",
      postObject
    ).then((output) => {
      if (output.status === "SUCCESS") {
        let smsMessageLogList = output.data.smsMessageLogList;
        let page = output.data.page;
        let getPermission = Utils.getRolePermission(output.data?.privilegeList);
        let getUpdatePermission = getPermission[3];
        let getDeletePermission = getPermission[4];

        for (let i = 0; i < smsMessageLogList.length; i++) {
          smsMessageLogList[i].createdOn = Utils.getUtcToLocalDateTimeZone(
            smsMessageLogList[i].createdOn
          );
        }
        for (let i = 0; i < smsMessageLogList.length; i++) {
          smsMessageLogList[i].checked = false;
          this.setState({
            allCheckBoxSelected: false,
            showToolbarBtn: false,
          });
        }
        this.setState({
          render: true,
          sendMessageOpen: false,
          deleteFromHistoryOpen: false,
          smsMessageLogList: smsMessageLogList,
          pageNo: page.pageNo,
          showPerPage: page.pageSize,
          totalPages: page.totalPages,
          totalRecords: page.total,
          getUpdatePermission: getUpdatePermission,
          getDeletePermission: getDeletePermission,
        });
      }
    });
  }

  onPaginationChange(returnProp) {
    let counter = returnProp.counter;
    let pageNo = this.state.pageNo + counter;
    let pageSize = returnProp.showPerPage;
    let buttonIndex = returnProp.buttonIndex;
    let currentPageIndex =
      typeof counter !== "undefined" ? pageNo : buttonIndex;
    let resetPageNo = returnProp.resetPageNo;
    if (resetPageNo === true) {
      currentPageIndex = 0;
    }
    let dataRows = this.state.smsMessageLogList;
    for (let i = 0; i < dataRows.length; i++) {
      dataRows[i].checked = false;
      this.setState({
        allCheckBoxSelected: false,
        showToolbarBtn: false,
      });
    }
    this.getSendHistoryList(currentPageIndex, pageSize);

    this.setState({
      pageNo: currentPageIndex,
    });
  }

  toRecipientsDetailList(e, data) {
    // let sendHistoryState = {
    //   messageId: data.id,
    //   pageNo: this.state.pageNo,
    //   pageSize: this.state.pageSize,
    // };
    // store.dispatch(
    //   ApplicationStateAction.setApplicationState({ sendHistoryState })
    // );
    this.props.navigate("/accountRecipients", {
      state: {
        businessDomain: this.state.businessDomain,
        accountId: this.state.accountId,
        eventId: data.eventId,
        smsMessageLog: data,
        eventName: this.state.eventName,
      },
    });
  }
  viewCancel() {
    if (this.state.businessDomain?.name === "EventText") {
      this.props.navigate("/accountEventList", {
        state: {
          accountId: this.state.accountId,
          businessDomain: this.state.businessDomain,
        },
      });
    } else {
      this.props.navigate("/viewAccount", {
        state: {
          action: "view",
          accountId: this.state.accountId,
          businessDomain: this.state.businessDomain,
        },
      });
    }
  }

  handleAccountDropdownClose = () => {
    this.setState({ open: false, anchorEl: null });
  };
  handleNext = () => {
    const updatedMessages = [
      ...this.state.questionItems,
      {
        question: this.state.closingTextMessage,
        step: this.state.questionItems?.length + 1,
      },
    ];

    this.setState((prevState) => ({
      currentIndex: Math.min(
        prevState.currentIndex + 1,
        updatedMessages.length - 1
      ),
    }));
  };

  handlePrev = () => {
    this.setState((prevState) => ({
      currentIndex: Math.max(prevState.currentIndex - 1, 0),
    }));
  };
  handleAccountDropdownOpen = (e, rowData) => {
    this.showMessagePreview(rowData);
    this.setState({
      open: true,
      anchorEl: e.currentTarget,
      messageContent: rowData.messageContent,
    });
  };
  showMessagePreview(rowData) {
    const postObject = {
      header: {
        ...this.header,
        tid: this.state.accountId,
      },
      event: { id: this.state.eventId },
      smsMessage: {
        id: rowData.messageId,
      },
    };
    AdminFetchServerData.callPostService(
      GetForTestAndSend_Url,
      postObject
    ).then((output) => {
      if (Utils.equalsIgnoreCase(output.status, "SUCCESS")) {
        let smsMessage = output.data.smsMessage;
        this.setState({
          textMessage: smsMessage.textMessage,
          closingTextMessage: smsMessage.closingMessage,
          questionItems: smsMessage.smsMessageQuestions,
          mmsUrl: smsMessage.mmsInfo?.mmsUrl,
          messageId: smsMessage?.id,
          messageType: smsMessage?.messageType,
          keyword: rowData?.keyword,
          messageName: rowData?.messagename,
        });
      }
    });
  }
  sendHistoryTitle() {
    return (
      <>
        {this.state.businessDomain?.name === "EventText" ? (
          <span className="d-flex">
            {"Usage History for"}:
            <span className="ms-1 me-1 d-flex" style={{ color: "#337ab7" }}>
              {this.state.eventName}
            </span>
          </span>
        ) : (
          "Usage History"
        )}
      </>
    );
  }

  render() {
    let updatedMessages = [
      ...this.state.questionItems,
      {
        question: this.state.closingTextMessage,
        step: this.state.questionItems?.length + 1,
      },
    ];
    return (
      <>
        <AdminMenuWithBreadScrum
          breadCrumb={this.breadCrumb}
          navigate={this.props.navigate}
          backCallback={this.viewCancel.bind(this)}
          name={this.sendHistoryTitle()}
        />
        <div className="row">
          <div className="col">
            <div className="col md-12">
              <div className="card rounded-0">
                <div
                  className="row justify-content-between"
                  style={{ padding: "0.6em 1.2rem" }}
                >
                  <div className="d-flex col-12 col-lg-5 col-xl-5">
                    <div className="col-12 text-start totalResults align-self-center">
                      <span>Total History: {this.state.totalRecords}</span>
                    </div>
                  </div>
                  <div className="d-flex col-12 col-lg-7 col-xl-7 justify-content-end">
                    <TextField
                      id="standard-search"
                      placeholder="Search"
                      type="text"
                      variant="standard"
                      value={this.state.searchText}
                      onChange={this.onSearchChange.bind(this)}
                      InputProps={{
                        startAdornment: (
                          <InputAdornment position="start">
                            <IconButton
                              onClick={this.getSendHistoryList.bind(
                                this,
                                0,
                                this.state.pageSize
                              )}
                            >
                              <SearchIcon />
                            </IconButton>
                          </InputAdornment>
                        ),
                      }}
                    />
                  </div>
                </div>
                <div className="table-responsive paginationTable">
                  <table className="table text-start table-hover">
                    <thead className="apPaginationTableThead">
                      <tr>
                        <th className="col fw-bold"></th>
                        <th className="col fw-bold">Message</th>
                        <th className="col fw-bold">Message Type</th>
                        <th className="col fw-bold">Sent By</th>
                        <th className="col fw-bold">Send Date/Time</th>
                        <th className="col fw-bold">Contacts</th>
                        <th className="col fw-bold">History Type</th>
                      </tr>
                    </thead>
                    <tbody>
                      {this.state.smsMessageLogList?.map((rowData, index) => (
                        <tr
                          key={index}
                          style={{
                            backgroundColor:
                              rowData.id === this.state.messageId
                                ? "#e6effc"
                                : "",
                          }}
                        >
                          <td style={{ width: "40px" }}>
                            <span
                              style={{
                                backgroundColor: rowData.hashColor,
                                width: 20,
                                height: 20,
                                borderRadius: 3,
                                display: "inline-block",
                                marginTop: "6px",
                                // border: "1px solid #ccc",
                              }}
                            />
                          </td>
                          <td style={{ width: "280px" }}>
                            <span
                              className="anchortag"
                              onClick={(e) =>
                                this.handleAccountDropdownOpen(e, rowData)
                              }
                            >
                              {Utils.truncateString(rowData.messageName, 30)}
                              &nbsp;
                              {rowData.isMms ? "(MMS)" : ""}
                            </span>
                          </td>
                          <td style={{ width: "220px" }}>
                            {rowData.messageType}
                          </td>
                          <td style={{ width: "220px" }}>
                            {rowData.createdBy}
                          </td>
                          <td style={{ width: "280px" }}>
                            {rowData.createdOn}
                          </td>
                          <td style={{ width: "180px" }}>
                            <span
                              className="anchortag"
                              onClick={(e) =>
                                this.toRecipientsDetailList(e, rowData)
                              }
                            >
                              {`${rowData.contactCount} Numbers`}
                            </span>
                          </td>
                          <td style={{ width: "180px" }}>
                            {rowData.isscheduled
                              ? "Scheduled Sends"
                              : "Send History"}
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
                {this.state.totalRecords === 0 && (
                  <div
                    className="row text-center"
                    style={{ padding: "6px 20px" }}
                  >
                    <h5 className="dataNotAvailable">No data found.</h5>
                  </div>
                )}
                {this.state.totalRecords > this.state.pageSize && (
                  <div className="row justify-content-between pagination p-1">
                    <div className="d-flex col-12 col-lg-4 col-xl-4">
                      <div className="pageSize col-12 text-start">
                        <span>Messages Sent: {Utils.formatWithCommas(this.state.totalRecords)}</span>
                      </div>
                    </div>
                    <div className="d-flex col-12 col-lg-8 col-xl-8">
                      <div className="col-12 text-end">
                        <Pagination
                          showPerPage={this.state.showPerPage}
                          pageNo={this.state.pageNo}
                          onPaginationChange={this.onPaginationChange.bind(
                            this
                          )}
                          total={this.state.totalRecords}
                        />
                      </div>
                    </div>
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
        <Menu
          anchorEl={this.state.anchorEl}
          id="dropdown-menu1"
          className="filterDropdownMenu"
          open={this.state.open}
          onClose={this.handleAccountDropdownClose.bind(this)}
          PaperProps={{
            elevation: 0,
            sx: {
              overflow: "visible",
              filter: "drop-shadow(0px 2px 8px rgba(0,0,0,0.32))",
              mt: 1.5,
              "& .MuiAvatar-root": {
                width: 32,
                height: 32,
                ml: -0.5,
                mr: 1,
              },
              "&:before": {
                content: '""',
                display: "block",
                position: "absolute",
                top: 0,
                left: 20,
                width: 10,
                height: 10,
                bgcolor: "background.paper",
                transform: "translateY(-50%) rotate(45deg)",
                zIndex: 0,
              },
            },
          }}
          transformOrigin={{ horizontal: "left", vertical: "top" }}
          anchorOrigin={{ horizontal: "left", vertical: "bottom" }}
        >
          <span className="closeIcon">
            <IconButton
              aria-label="close"
              onClick={this.handleAccountDropdownClose.bind(this)}
              style={{
                position: "absolute",
                right: 8,
                top: 4,
                color: (theme) => theme.palette.grey[500],
              }}
            >
              <CloseIcon style={{ color: "#000", fontWeight: "600" }} />
            </IconButton>
          </span>
          <div
            style={{
              cursor: "pointer",
              width: "400px",
              height: "100%",
              fontSize: "14px",
            }}
          >
            <div className="row ps-2 pe-2">
              <h5 className="fw-bold">Message Preview</h5>
              {!(
                Utils.equalsIgnoreCase(
                  this.state.messageType?.type,
                  MESSAGE_TYPES.interactive
                ) ||
                Utils.equalsIgnoreCase(
                  this.state.messageType?.type,
                  MESSAGE_TYPES.interactivePledge
                )
              ) && (
                  <>
                    <div className="col-md-12">
                      <div className="chat-bubble">
                        {Utils.equalsIgnoreCase(
                          this.state.messageType?.type,
                          MESSAGE_TYPES.fundraising
                        )
                          ? this.state.amountQuestion
                          : this.state.textMessage}
                      </div>
                    </div>
                  </>
                )}
              {(Utils.equalsIgnoreCase(
                this.state.messageType?.type,
                MESSAGE_TYPES.interactive
              ) ||
                Utils.equalsIgnoreCase(
                  this.state.messageType?.type,
                  MESSAGE_TYPES.interactivePledge
                )) && (
                  <>
                    <div className="col-sm-12 mt-2">
                      <div className="chat-bubble" style={{ height: "90px" }}>
                        <span variant="body2">
                          {updatedMessages[this.state.currentIndex]?.question}
                        </span>

                        {this.state.currentIndex <
                          updatedMessages?.length - 1 && (
                            <IconButton
                              onClick={this.handleNext}
                              sx={{
                                position: "absolute",
                                bottom: 8,
                                right: 8,
                                backgroundColor: "white",
                                "&:hover": {
                                  backgroundColor: "#eee",
                                },
                              }}
                              size="small"
                            >
                              <ArrowForward fontSize="small" />
                            </IconButton>
                          )}

                        {this.state.currentIndex > 0 && (
                          <IconButton
                            onClick={this.handlePrev}
                            sx={{
                              position: "absolute",
                              bottom: 8,
                              left: 8,
                              backgroundColor: "white",
                              "&:hover": {
                                backgroundColor: "#eee",
                              },
                            }}
                            size="small"
                          >
                            <ArrowBack fontSize="small" />
                          </IconButton>
                        )}
                      </div>
                    </div>
                  </>
                )}
              {this.state.mmsUrl && (
                <>
                  <div className="col-md-12 mt-3">
                    <label
                      className="col-form-label fw-bold"
                      htmlFor="basic-default-Image"
                      id="assetFormLabel"
                    >
                      Image
                    </label>
                    <div className="col-sm-12" id="givbeeText">
                      <img
                        style={{
                          width: "-webkit-fill-available",
                          height: "6em",
                          objectFit: "contain",
                          objectPosition: "left",
                        }}
                        alt=""
                        src={this.state.mmsUrl ? this.state.mmsUrl : ""}
                      />
                    </div>
                  </div>
                </>
              )}
            </div>
          </div>
        </Menu>
      </>
    );
  }
}
export default withRouter(AccountSendHistory);
